import React, { Component } from 'react';
import ReactFitText from 'react-fittext';
import ScrollDown from '../../scroll-down';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import { detectBrowser, isMobileDevice } from '../../../utils/helper-functions';
import styles from './home-amplified.module.css';

import {
  addEvent,
  asTime,
  two,
} from '../../../utils/helper-functions/video-sync';

class HomeAmplified extends Component {
  constructor() {
    super();
    this.state = {
      ready: false,
      videoOne: null,
      videoTwo: null,
    };
  }

  componentDidMount() {
    if (this.videoOne && this.videoTwo) {
      this.setState({
        ready: true,
        videoOne: this.videoOne,
        videoTwo: this.videoTwo,
      });
    }
  }

  render() {
    const { ready, videoOne, videoTwo } = this.state;
    const animationConfig = {
      delay: 200,
      duration: 900,
      easing: easings.easeCubicOut,
    };

    setTimeout(() => {
      syncAndPlay();
    }, 3000);

    const syncAndPlay = () => {
      if (ready) {
        if (videoOne.paused) {
          if (videoOne.ended) {
            videoOne.currentTime = 0;
            videoTwo.currentTime = 0;
          }
          videoTwo.currentTime = videoOne.currentTime;
          const playVideoOnePromise = videoOne.play();
          if (playVideoOnePromise !== null) {
            playVideoOnePromise.catch(() => {
              videoOne.play();
            });
          }
        } else {
          videoOne.pause();
        }
      }
    };

    addEvent(videoOne, 'play', () => {
      const playVideoTwoPromise = videoTwo.play();
      if (playVideoTwoPromise !== null) {
        playVideoTwoPromise.catch(() => {
          videoTwo.play();
        });
      }
    });

    addEvent(videoOne, 'pause', () => {
      videoTwo.pause();
    });

    return (
      <React.Fragment>
        <div
          className={
            detectBrowser() === 'iOS'
              ? [styles.wrapper, styles.wrapperIOS].join(' ')
              : styles.wrapper
          }
        >
          <Spring
            from={{ bottom: '0%' }}
            to={{ bottom: this.state.allVideosLoaded ? '100%' : '0%' }}
          >
            {animation => <div className={styles.bgCover} style={animation} />}
          </Spring>

          <div className={styles.contentWrapper}>
            <Spring
              from={{ opacity: 0, transform: 'translateY(120px)' }}
              to={{
                opacity: 1,
                transform: 'translateY(0)',
              }}
              config={animationConfig}
            >
              {animation => (
                <div className={styles.content} style={animation}>
                  <div className={styles.headline}>
                    <ReactFitText compressor={0.5} maxFontSize={100}>
                      <h1 className={styles.amp}>
                        Your
                        <br />
                        Brand,
                        <br />
                        Amplified.
                      </h1>
                    </ReactFitText>
                  </div>
                  <div className={styles.headlineMobile}>
                    <ReactFitText compressor={0.45} maxFontSize={50}>
                      <h1 className={styles.amp}>
                        Your
                        <br />
                        Brand,
                        <br />
                        Amplified.
                      </h1>
                    </ReactFitText>
                  </div>
                  <h3 className={styles.message}>
                    We’re a creative marketing agency.
                    <span className={styles.messageBreak} /> And we’re here to
                    help you make an impact.
                  </h3>
                </div>
              )}
            </Spring>

            <div className={styles.videoBoxWrapper}>
              {isMobileDevice() ? null : (
                <div className={styles.videoBox}>
                  <div className={styles.videoBoxPlacement}>
                    <video
                      preload="auto"
                      ref={videoTwo => (this.videoTwo = videoTwo)}
                      muted="muted"
                      loop
                    >
                      <source src="https://jk-wp.jkstaging.com/wp-content/uploads/2019/07/foreground_half.mp4" />
                    </video>
                  </div>
                </div>
              )}
            </div>
          </div>

          <ScrollDown color="white" />
          <div
            className={styles.videoBGWrapper}
            style={{ background: '#5105c1' }}
          >
            {isMobileDevice() ? null : (
              <video
                className={styles.videoBG}
                preload="auto"
                ref={videoOne => (this.videoOne = videoOne)}
                muted="muted"
                loop
              >
                <source src="https://jk-wp.jkstaging.com/wp-content/uploads/2019/07/background_half.mp4" />
              </video>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HomeAmplified;



// WEBPACK FOOTER //
// ./src/components/home/home-amplified/index.js